import React, { useEffect, useMemo, useParams, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { Box, Button, IconButton, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { Card } from "@mui/material";
import TableMaestroDeep from "../../verticales/TableMaestrosDepp.tsx";
import fetchData from "verticales/FetchData";
import MDButton from "components/MDButton";
import UtilModal from "verticales/UtilModalDisponibilidad.js";
import AppLoading from "verticales/AppLoading.tsx";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import Tooltip from "@mui/material/Tooltip";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CardsProductosCliente from "./componentes/cardsDinamicas";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 54,
  pl: 2,
  pr: 2,
  pt: 0,
  pb: 2,
};

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "deep-client";

function BusquedaCliente(props: any) {
  // declaracion de variables de la pantalla
  const [datoBusqueda, setDatoBusqueda] = useState("");
  const [data, setData] = useState([]);

  const handleButtonClick = async () => {
    const params = {
      action: "get-clientes",
      params: {
        datoBusqueda,
      },
    };

    setBlocking(true);

    try {
      const resp = await fetchData(url, context, params);
      // console.log("Data cliente...", resp.rows);
      setData(resp.rows);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setData([]);
    } finally {
      setBlocking(false);
    }
  };

  /** Segmento de la ventana emergente  */
  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const [blocking, setBlocking] = useState(false);

  const handleOpenModal = (row) => {
    setRowSelect(row);
    setOpenModal(true);
  };

  const handleCloseModal = async (refresh) => {
    setOpenModal(false);
  };
  const renderView = () => {
    return (
      <CardsProductosCliente
        row={rowSelect}
        data={rowSelect.original}
        handleCloseModal={handleCloseModal}
      />
    );
  };

  const columns = useMemo(
    () => [
      { header: "database", accessorKey: "name_database" },
      { header: "companias", accessorKey: "companias" },
      { header: "nro_cia_activas", accessorKey: "nro_cia_activas" },
      { header: "storage", accessorKey: "tamano" },
      { header: "estado", accessorKey: "estado" },
      { header: "rds_id", accessorKey: "rds_id" },
      { header: "repeticion", accessorKey: "repeticion" },
    ],
    []
  );

  let renderOpcRowsSid = (row) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}>
        <Tooltip title="Ver">
          <IconButton onClick={() => handleOpenModal(row)}>
            <AnalyticsIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6} lg={12}>
            <MDBox m={1}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <TextField
                    id="datoBusqueda"
                    value={datoBusqueda}
                    onChange={(event) => setDatoBusqueda(event.target.value)}
                    label="Ingrese cliente o Nit"
                  />
                  <MDButton variant="contained" disableElevation onClick={handleButtonClick}>
                    Buscar
                  </MDButton>
                </Box>
              </LocalizationProvider>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              {blocking ? (
                <AppLoading titleCustom={"deep-clientes"} />
              ) : (
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox m={1}>
                    <React.Fragment>
                      <TableMaestroDeep
                        arrayColumns={columns}
                        data={data}
                        handleOpenModal={handleOpenModal}
                        height={250}
                        renderOpcRows={renderOpcRowsSid}
                      />
                    </React.Fragment>
                  </MDBox>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
    </DashboardLayout>
  );
}

export default BusquedaCliente;
